/**
 * Utility to check if a user has access to a specific application node.
 * Implement ADMIN override and privilege-based checks.
 */
export const checkAccess = (user, nodeName) => {
  if (!user) return false;

  // Robust property lookup for username and role
  const username = (user.username || user.userName || user.loginId || user.userId || user.appUserId || "").toString().toUpperCase();
  const role = (user.role || user.roleName || user.groupName || "").toString().toUpperCase();
  const privileges = user.privileges || [];

  // Global ADMIN override (by Name, by Role, or by SYSTEM_ADMIN privilege)
  if (
    username === 'ADMIN' || 
    role === 'ADMIN' || 
    privileges.includes('SYSTEM_ADMIN') ||
    privileges.includes('ADMIN')
  ) {
    return true;
  }

  // Privilege mapping based on requirement
  const nodePrivilegeMap = {
    'Edit Product': 'STABILITY_EDIT',
    'Level 1 Approval': 'STABILITY_LEVEL1',
    'Level1 Approval': 'STABILITY_LEVEL1',
    'Final Approval': 'STABILITY_FINAL',
    'View Product': 'STABILITY_VIEW',
    'Edit Log Report': 'STABILITY_REPORT',
    'User Maintenance': 'SYSTEM_USER',
    'User Group': 'SYSTEM_GROUP',
    'Location': 'SYSTEM_LOCATION',
    'License Management': 'SYSTEM_LICENSE',
    'System Audit Trail': 'SYSTEM_AUDIT',
    'Access Log Report': 'SYSTEM_ACCESS_LOG',
    'Admin': 'SYSTEM_ADMIN'
  };

  // Normalize nodeName to handle potential typos/spaces
  const normalizedNodeName = nodeName?.trim().replace(/\s+/g, ' ');
  const requiredPrivilege = nodePrivilegeMap[normalizedNodeName];
  
  // If we don't have a mapping for the node, it might be a folder.
  // Folder logic is handled by the caller (enabled if child is enabled).
  if (!requiredPrivilege) return false;

  return privileges.includes(requiredPrivilege);
};
